
import { service, BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
export default {
	// 列表
	getDataList(params) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/pages',
			method: 'get',
			params: params
		})
	},
	// 新增编辑
	save(data) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/save',
			method: 'post',
			data: data
		})
	},
	// 详情
	getDetail(id) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/detail?id=' + id,
			method: 'get'
		})
	},
	// 审核
	audit(data) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/check?' + searchParamsFormatter(data),
			method: 'post'

		})
	},
	// 上下架
	changeState(data) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/changeState?' + searchParamsFormatter(data),
			method: 'post'

		})
	},
	// 删除
	deleteStory(id) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/delete?id=' + id,
			method: 'post'

		})
	},
	// 中奖列表
	userPrizePages(params) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/userPrizePages',
			method: 'get',
			params

		})
	},
	// 奖品列表
	getPrizeList() {
		return service({
			url: '/cloud/activity/admin/anniversary2024/prizes',
			method: 'get'
		})
	},
	// 奖品列表
	savePrize(data) {
		return service({
			url: '/cloud/activity/admin/anniversary2024/savePrize',
			method: 'post',
			data
		})
	},
	// 导出参与人员列表
	exportUserList(params){
		return service({
			url: '/cloud/activity/admin/anniversary2024/exportExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
	// 导出参与人员列表
	exportUserPrizeExcel (params){
		return service({
			url: '/cloud/activity/admin/anniversary2024/exportUserPrizeExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
	}


}


// WEBPACK FOOTER //
// ./src/api/operateManage/anniversary_9.js